import React from "react";
import "./style.scss";

const ErrorField = ({ text }) => {
  return <div className={"error-field"}>{text}</div>;
};

export default ErrorField;
